import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfigs = {
  beta: {
    apiKey: "AIzaSyDMjzOsg-ww6FFWWBfR-4b5GCHnTrwaM9A",
    authDomain: "latte-test-61f73.firebaseapp.com",
    databaseURL: "https://latte-test-61f73-default-rtdb.firebaseio.com",
    projectId: "latte-test-61f73",
    storageBucket: "latte-test-61f73.appspot.com",
    messagingSenderId: "801510775394",
    appId: "1:801510775394:web:9a8442dfdc3961cf794f3b",
    measurementId: "G-BNY5NEJL6R"
  },
  admin: {
    apiKey: "AIzaSyAAD0XQiSXp33mUB9IDB9XOG2ym97FLDjw",
    authDomain: "latte-95453.firebaseapp.com",
    databaseURL: "https://latte-95453-default-rtdb.firebaseio.com",
    projectId: "latte-95453",
    storageBucket: "latte-95453.appspot.com",
    messagingSenderId: "475405869817",
    appId: "1:475405869817:web:662cc2a5a0e79c49eeb828",
    measurementId: "G-BJ8C0RD7YQ"
  }
};

// Prod requires explicit opt-in — everything else defaults to beta
const prodHostnames = new Set([
  'admin.latteconnect.app',
  'internal.admin.latteconnect.app',
]);

const getFirebaseConfig = () => {
  if (process.env.REACT_APP_ENV === 'prod') {
    return firebaseConfigs.admin;
  }

  if (typeof window !== 'undefined' && prodHostnames.has(window.location.hostname)) {
    return firebaseConfigs.admin;
  }

  return firebaseConfigs.beta;
};

const firebaseConfig = getFirebaseConfig();

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const storage = getStorage(app);

// Connect to emulators on localhost (REACT_APP_EMULATOR_MODE=all for e2e, otherwise functions only)
if (typeof window !== 'undefined' && window.location.hostname === 'localhost' && process.env.REACT_APP_ENV !== 'prod') {
  const emulatorMode = process.env.REACT_APP_EMULATOR_MODE;

  if (emulatorMode === 'all') {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    connectStorageEmulator(storage, 'localhost', 9199);
  } else {
    // Connect functions and storage locally, use remote QA for auth/firestore/database
    connectFunctionsEmulator(functions, 'localhost', 5001);
    connectStorageEmulator(storage, 'localhost', 9199);
  }
}

export { app, auth, analytics, db, functions, storage };